export const variables={
    API_URL:"https://libros-api-cors.onrender.com/api/",
    PHOTO_URL:"https://libros-api-cors.onrender.com/Photos/"
}

// son los puntos de salida de la app ahora los importamos en Genero.js componente, vamos allí